<app-accounting-template
        [title]="title"
        [apiUrl]="apiUrl"
        [tableInfo]="info"
        [type]="'PENDING_CUSTOMER_RECEIVING_CONFIRMATION'"
        [rowActionsSettings]="AccountingRowActionsSettings"
        [topActionsSettings]="topActionsSettings"
        [filtersSettings]="filtersSettings"
></app-accounting-template>
